document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('#filter-buttons .action-button');
    const ymalWrap = document.querySelector('.js-ymal-wrap');
    
    if (!ymalWrap) {
        return;
    }

    // Function to initialize toggleReveal
    function initToggleReveal() {
        if (typeof $ !== 'undefined' && typeof $.fn.toggleReveal === 'function') {
            $('.js-toggle-reveal').toggleReveal();
        } else {
            console.warn('jQuery or toggleReveal plugin not loaded');
        }
    }

    // Function to load content via AJAX
    async function loadContent(path) {
        try {
            const response = await fetch(path);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const html = await response.text();
            
            // Store scroll position if needed
            const scrollPosition = window.scrollY;
            
            // Update content
            ymalWrap.innerHTML = html;
            
            // Initialize toggleReveal on new content
            initToggleReveal();
            
            // Restore scroll position if needed
            window.scrollTo(0, scrollPosition);
            
        } catch (error) {
            console.error('Error loading content:', error);
            ymalWrap.innerHTML = '<p>Error loading content. Please try again.</p>';
        }
    }
    
    // Add click event listeners to buttons
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            // Remove active class from all buttons
            buttons.forEach(btn => btn.classList.remove('action-button--active'));
            
            // Add active class to clicked button
            this.classList.add('action-button--active');
            // Load content
            const path = this.getAttribute('data-ab795-url');
            if (path) {
                loadContent(path);
            }
        });
    });
    
    // Initialize toggleReveal on initial load
    initToggleReveal();
    
    // Load initial content if needed
    const activeButton = document.querySelector('#filter-buttons .action-button--active');
    if (activeButton) {
        const initialPath = activeButton.getAttribute('data-ab795-url');
        if (initialPath) {
            loadContent(initialPath);
        }
    }
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/abtests/ab795.js